module.exports = `${require.publicPath}icon07.abf13cb4.png`;